export default "__VITE_ASSET__DBoWZlQE__"